const isHtmlContent = (str: string): boolean => {
  if (/<[^>]+>/i.test(str)) return true;

  if (/&[#\w]+;/i.test(str)) return true;

  if (/javascript:|on\w+\s*=/i.test(str)) return true;

  return false;
};

export const sanitizeMessage = (
  message: string,
  defaultMessage: string
): string => {
  if (!message || typeof message !== "string" || message.trim().length === 0) {
    return defaultMessage;
  }

  if (isHtmlContent(message)) {
    return defaultMessage;
  }

  return message;
};
